import common from "../common";
import GelButton from "../ui/gel/GelButton";
import GelHackButton from "../ui/gel/GelHackButton";
import GelScene from "../ui/gel/GelScene";

export default class DeleteUserScene extends GelScene {
    constructor() {
        super();

        this._overlay = null;
        this._confirmButton = null;
        this._declineButton = null;
    }

    init() {
        super.init();

        this._overlay = new PIXI.Sprite(PIXI.Texture.WHITE);
        this._overlay.height = P3.View.height;
        this._overlay.alpha = 0.7;
        this._overlay.tint = 0x0;
        this._overlay.visible = false;
        this.addChild(this._overlay);

        this.initPanel();
    }

    resize() {
        super.resize();

        this._overlay.x = (common.STAGE_WIDTH - P3.View.width) * 0.5;
        this._overlay.width = P3.View.width;
    }

    animateIn() {
        if (this.parent === null) return;

        let to = this._overlay.alpha;
        this._overlay.alpha = 0;
        new P3.utils.TWEEN.Tween(this._overlay, this._tweens)
            .to({alpha: to}, 240)
            .easing(P3.utils.TWEEN.Easing.Quadratic.InOut)
            .onStart(() => {
                this._overlay.visible = true;
            })
            .start();

        new P3.utils.TWEEN.Tween(this._panel, this._tweens)
            .to({alpha: 1}, 240)
            .easing(P3.utils.TWEEN.Easing.Quadratic.InOut)
            .onStart(() => {
                this._panel.visible = true;
            })
            .start();

        to = this._panel.y;
        this._panel.y += 80;
        new P3.utils.TWEEN.Tween(this._panel, this._tweens)
            .to({y: to}, 340)
            .easing(P3.utils.TWEEN.Easing.Cubic.Out)
            .start();

        this._confirmButton.scale.set(0);
        new P3.utils.TWEEN.Tween(this._confirmButton.scale, this._tweens)
            .to({x: 1, y: 1}, 340)
            .easing(P3.utils.TWEEN.Easing.Back.Out)
            .delay(260)
            .onStart(() => {
                this._confirmButton.interactive = true;
                this._confirmButton.visible = true;
            })
            .start();

        this._declineButton.scale.set(0);
        new P3.utils.TWEEN.Tween(this._declineButton.scale, this._tweens)
            .to({x: 1, y: 1}, 340)
            .easing(P3.utils.TWEEN.Easing.Back.Out)
            .delay(220)
            .onStart(() => {
                this._declineButton.interactive = true;
                this._declineButton.visible = true;
            })
            .start();
    }

    animateOut(callback, scope) {
        new P3.utils.TWEEN.Tween(this, this._tweens)
            .to({alpha: 0}, 240)
            .easing(P3.utils.TWEEN.Easing.Quadratic.InOut)
            .onComplete(() => {
                callback && callback.call(scope);
            })
            .start();
    }

    initPanel() {
        this._panel = new PIXI.Sprite(P3.assets.texture("ui_results_panel_equip"));
        this._panel.position.set(common.STAGE_WIDTH * 0.5, P3.View.height - 200);
        this._panel.anchor.set(0.5);
        this._panel.visible = false;
        this.addChild(this._panel);

        this._panel.label = new PIXI.extras.BitmapText("Are you sure you want to delete this character?",
            {font: "34px BBC Reith Sans", align: "center"});
        this._panel.label.position.set(0, -16);
        this._panel.label.anchor.set(0.5);
        this._panel.label.maxWidth = this._panel.texture.width * 0.8;
        this._panel.label.lineHeight = 4;
        this._panel.addChild(this._panel.label);

        this._confirmButton = GelHackButton.create(
            P3.assets.texture("btn_large_normal"),
            P3.assets.texture("btn_large_over"),
            P3.assets.texture("btn_large_down"),
            P3.assets.texture("ui_icon_accept_nongel_medium")
        );
        this._confirmButton.position.set(this._panel.position.x + 120, this._panel.position.y + 88);
        this._confirmButton.visible = false;
        this._confirmButton.tabIndex = GelButton.TAB_INDEX_LEVEL_0 + 1;
        this._confirmButton.interactive = false;
        this._confirmButton.signals.click.add(this.onConfirmButtonClick, this);
        this.addChild(this._confirmButton);

        this._declineButton = GelHackButton.create(
            P3.assets.texture("btn_large_normal"),
            P3.assets.texture("btn_large_over"),
            P3.assets.texture("btn_large_down"),
            P3.assets.texture("ui_icon_decline_nongel_medium")
        );
        this._declineButton.position.set(this._panel.position.x - 120, this._panel.position.y + 88);
        this._declineButton.visible = false;
        this._declineButton.tabIndex = GelButton.TAB_INDEX_LEVEL_0;
        this._declineButton.interactive = false;
        this._declineButton.signals.click.add(this.onDeclineButtonClick, this);
        this.addChild(this._declineButton);
    }

    onConfirmButtonClick(button) {
        this._confirmButton.enabled = false;
        this._declineButton.enabled = false;

        this.animateOut(() => {
            this.signals.next.dispatch(this);
        });
    }

    onDeclineButtonClick(button) {
        this._confirmButton.enabled = false;
        this._declineButton.enabled = false;

        this.animateOut(() => {
            this.signals.previous.dispatch(this);
        });
    }
}